/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateFarmerDto,
  FarmerDto,
  FarmersControllerListParams,
  FarmersListDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * Returns farmers visible to the caller. admin sees all; coop_admin sees farmers in cooperatives where they are admin_user_id. Order: most recent first.
 * @summary List farmers (paginated, coop-scoped)
 */
export const farmersControllerList = (
    params?: FarmersControllerListParams,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<FarmersListDto>(
      {url: `/farmers`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getFarmersControllerListQueryKey = (params?: FarmersControllerListParams,) => {
    return [
    `/farmers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getFarmersControllerListQueryOptions = <TData = Awaited<ReturnType<typeof farmersControllerList>>, TError = unknown>(params?: FarmersControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmersControllerList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFarmersControllerListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof farmersControllerList>>> = ({ signal }) => farmersControllerList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof farmersControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FarmersControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof farmersControllerList>>>
export type FarmersControllerListQueryError = unknown


export function useFarmersControllerList<TData = Awaited<ReturnType<typeof farmersControllerList>>, TError = unknown>(
 params: undefined |  FarmersControllerListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmersControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof farmersControllerList>>,
          TError,
          Awaited<ReturnType<typeof farmersControllerList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFarmersControllerList<TData = Awaited<ReturnType<typeof farmersControllerList>>, TError = unknown>(
 params?: FarmersControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmersControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof farmersControllerList>>,
          TError,
          Awaited<ReturnType<typeof farmersControllerList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFarmersControllerList<TData = Awaited<ReturnType<typeof farmersControllerList>>, TError = unknown>(
 params?: FarmersControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmersControllerList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List farmers (paginated, coop-scoped)
 */

export function useFarmersControllerList<TData = Awaited<ReturnType<typeof farmersControllerList>>, TError = unknown>(
 params?: FarmersControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmersControllerList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFarmersControllerListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a `users` row (role=farmer) + a `farmer_profiles` row + an audit_log entry in one transaction. Cooperative is derived from the caller (`cooperatives.admin_user_id = caller`). A coop_admin who admins zero cooperatives gets a 400. Phone conflicts surface as 409.
 * @summary Register a new farmer + farmer_profile (coop-scoped)
 */
export const farmersControllerCreate = (
    createFarmerDto: CreateFarmerDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<FarmerDto>(
      {url: `/farmers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFarmerDto, signal
    },
      );
    }
  


export const getFarmersControllerCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof farmersControllerCreate>>, TError,{data: CreateFarmerDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof farmersControllerCreate>>, TError,{data: CreateFarmerDto}, TContext> => {

const mutationKey = ['farmersControllerCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof farmersControllerCreate>>, {data: CreateFarmerDto}> = (props) => {
          const {data} = props ?? {};

          return  farmersControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FarmersControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof farmersControllerCreate>>>
    export type FarmersControllerCreateMutationBody = CreateFarmerDto
    export type FarmersControllerCreateMutationError = void

    /**
 * @summary Register a new farmer + farmer_profile (coop-scoped)
 */
export const useFarmersControllerCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof farmersControllerCreate>>, TError,{data: CreateFarmerDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof farmersControllerCreate>>,
        TError,
        {data: CreateFarmerDto},
        TContext
      > => {

      const mutationOptions = getFarmersControllerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns one farmer by user_id. admin reads any farmer; coop_admin reads only farmers in cooperatives where they are admin_user_id (403 otherwise). A non-existent user_id is 404; an existing-but-out-of-scope farmer is 403. Fixes TD-071 - the web previously fetched the list and `.find()`-ed the row.
 * @summary Read a single farmer by user id (coop-scoped)
 */
export const farmersControllerGetOne = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<FarmerDto>(
      {url: `/farmers/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getFarmersControllerGetOneQueryKey = (id?: string,) => {
    return [
    `/farmers/${id}`
    ] as const;
    }

    
export const getFarmersControllerGetOneQueryOptions = <TData = Awaited<ReturnType<typeof farmersControllerGetOne>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmersControllerGetOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFarmersControllerGetOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof farmersControllerGetOne>>> = ({ signal }) => farmersControllerGetOne(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof farmersControllerGetOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FarmersControllerGetOneQueryResult = NonNullable<Awaited<ReturnType<typeof farmersControllerGetOne>>>
export type FarmersControllerGetOneQueryError = void


export function useFarmersControllerGetOne<TData = Awaited<ReturnType<typeof farmersControllerGetOne>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmersControllerGetOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof farmersControllerGetOne>>,
          TError,
          Awaited<ReturnType<typeof farmersControllerGetOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFarmersControllerGetOne<TData = Awaited<ReturnType<typeof farmersControllerGetOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmersControllerGetOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof farmersControllerGetOne>>,
          TError,
          Awaited<ReturnType<typeof farmersControllerGetOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFarmersControllerGetOne<TData = Awaited<ReturnType<typeof farmersControllerGetOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmersControllerGetOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Read a single farmer by user id (coop-scoped)
 */

export function useFarmersControllerGetOne<TData = Awaited<ReturnType<typeof farmersControllerGetOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmersControllerGetOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFarmersControllerGetOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




